<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">{{ 'UTME Details'.toUpperCase() }}</div>
      </v-col>
    </v-row>
    <v-form ref="form" v-model="dataValid">
      <v-alert type="info" class="mt-4" v-if="getUser != null && getUser.admission.applicationType.autoLoadUtme">
        Check and make sure the information below match yours. If it does not, notify the institution
      </v-alert>
      <v-alert type="warning" class="mt-4" v-else>
        Make sure to provide correct information as editing will not be allowed after submission
      </v-alert>
      <v-row justify="space-between">
        <v-col cols="12" md="6">
          <v-select dense outlined label="Year" :disabled="!canEdit" :items="years" v-model="obj.year"></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field dense outlined label="Registration number" v-model="obj.jambRegNumber" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="space-between">
        <!--    first subject    -->
        <v-col cols="12" md="4">
          <div class="basic--text font-weight-bold">Subject 1</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-select outlined dense item-text="name" item-value="id" :items="subjects" label="Subject" :rules="textRules" required v-model="obj.subject1" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number" outlined dense label="Score" :rules="textRules" required v-model="obj.score1" :disabled="!canEdit"></v-text-field>
        </v-col>
        <!--    second subject    -->
        <v-col cols="12" md="4">
          <div class="basic--text font-weight-bold">Subject 2</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-select outlined dense item-text="name" item-value="id" :items="subjects" label="Subject" :rules="textRules" required v-model="obj.subject2" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number" outlined dense label="Score" :rules="textRules" required v-model="obj.score2" :disabled="!canEdit"></v-text-field>
        </v-col>
        <!--    third subject    -->
        <v-col cols="12" md="4">
          <div class="basic--text font-weight-bold">Subject 3</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-select outlined dense item-text="name" item-value="id" :items="subjects" label="Subject" :rules="textRules" required v-model="obj.subject3" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number" outlined dense label="Score" :rules="textRules" required v-model="obj.score3" :disabled="!canEdit"></v-text-field>
        </v-col>
        <!--    fourth subject    -->
        <v-col cols="12" md="4">
          <div class="basic--text font-weight-bold">Subject 4</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-select outlined dense item-text="name" item-value="id" :items="subjects" label="Subject" :rules="textRules" required v-model="obj.subject4" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number" outlined dense label="Score" :rules="textRules" required v-model="obj.score4" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : "Previous" }}</v-btn>
      <v-btn color="error" depressed v-if="canEdit && !noHeader">Reset</v-btn>
      <v-btn color="primary" depressed @click="saveData" :disabled="!dataValid" v-if="canEdit">{{  noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" depressed @click="success" v-if="userData != null || !this.getUser.modeOfEntry.requireUtmeScores">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>
<script>

import ValidationRules from "@/shared/ValidationRules";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import DateUtil from "@/shared/DateUtil";
import {mapGetters} from "vuex";

export default {
  name: "UTMEDetails",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data () {
    return {
      obj: {
        year: null
      },
      subjects: [],
      textRules: ValidationRules.textRules,
      numberRules: ValidationRules.numericRules,
      userData: null,
      dataValid: true,
      messageType: '',
      message: '',
      messageShow: false,
      loading: false,
      years: DateUtil.getYearsArray(2010),
      // this property is required to enabled modification of fields when preloading
      enableEdit: false,
    }
  },
  methods: {
    success() {
      this.$emit('success')
    },

    loadSubjects(){
      this.loading = true
      Api.requirements.getSubjects()
          .then(res => this.subjects = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    saveData(){
      this.loading = true
      Api.applicants.utmeUpdate(this.getUser.id, this.obj)
          .then(() => {
            this.message = 'UTME details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadUTMEDetails(){
      this.loading = true
      Api.applicants.getUTMEDetails(this.getUser.userId)
          .then(res => {
            this.userData = res.data
            this.prefillData()
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    check() {
      this.loading = true;
      Api.applicants.nextToUTMEUpdate(this.getUser.id).then((res) => {
        this.loading = false;
        this.$store.commit("setUTMEDetails", res.data);
      }).catch((err) => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false)
    },

    checkRequirement(){
      return this.getUser != null && (!this.getUser.admission.applicationType.utmeDetailsEnabled ||  (this.getUser.modeOfEntry != null &&  !this.getUser.modeOfEntry.requireUtmeScores))
    },

    prefillData(){
      this.enableEdit = true
      if(this.userData != null){
        let u = this.userData
        this.obj.year = +u.year
        this.obj.jambRegNumber = u.jambRegNumber
        this.obj.subject1 = u.subject1.id
        this.obj.subject2 = u.subject2.id
        this.obj.subject3 = u.subject3.id
        this.obj.subject4 = u.subject4.id
        this.obj.score1 = u.score1
        this.obj.score2 = u.score2
        this.obj.score3 = u.score3
        this.obj.score4 = u.score4
      }
      // lock back
      this.enableEdit = false
    }
  },

  watch:{
    getUser: function(){
      if(this.checkRequirement()) {
        this.success()
        return
      }

      if(this.getUser != null)
        this.loadUTMEDetails()
    },

    userData: function(val){
      if(val != null){
        // this.success()
      }
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getInformation']),
    canEdit: function(){
      return (this.getUser != null && this.getUser.admission.applicationType.autoLoadUtme === false) || this.enableEdit
    }
  },

  created() {
    if(this.checkRequirement()) {

      this.success()
      return
    }



    if(this.getUser != null) {
      this.check();
      this.loadUTMEDetails()
    }


    this.loadSubjects()
    this.noHeader && this.$emit('update-title', "UTME Details")
  }
}
</script>

<style scoped>

</style>
